/** The advert installers see on My Website in place of the old template gallery — image or video, headline, copy, CTA. */
import React, { useEffect, useState } from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import API_URL from '@/config/api';
import { Button } from '@/components/ui/button';
import { wget } from './api';

function embedUrl(url) {
  if (!url) return null;
  const yt = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|shorts\/|embed\/))([\w-]{6,})/);
  if (yt) return `https://www.youtube-nocookie.com/embed/${yt[1]}`;
  const vm = url.match(/vimeo\.com\/(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  return null;
}

export function AdvertMedia({ advert, className = '' }) {
  const embed = embedUrl(advert?.video_url);
  const m = advert?.media;
  if (!m && !embed) return null;
  if (embed) return <div className={`aspect-video bg-black ${className}`}><iframe src={embed} title="Website advert" className="w-full h-full" allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen data-testid="advert-embed" /></div>;
  if (m.kind === 'video') return <video src={`${API_URL}${m.url}`} controls playsInline className={`w-full bg-black ${className}`} data-testid="advert-video" />;
  return <img src={`${API_URL}${m.url}`} alt={advert.headline} className={`w-full object-cover ${className}`} data-testid="advert-image" />;
}

export function WebsiteAdvert({ onStart, ctaNote, hasOrders }) {
  const [advert, setAdvert] = useState(null);
  useEffect(() => { wget('/website/advert').then(setAdvert).catch(() => setAdvert({})); }, []);
  if (!advert) return null;
  return (
    <div className="bg-slate-900 text-white rounded-2xl overflow-hidden" data-testid="mw-start">
      <AdvertMedia advert={advert} />
      <div className="p-6">
        <div className="flex items-center gap-2 text-teal-300 text-xs font-bold uppercase tracking-wider"><Sparkles className="w-4 h-4" /> {hasOrders ? 'Another website?' : 'Get your website'}</div>
        <h2 className="text-xl font-bold mt-2" data-testid="advert-headline">{advert.headline}</h2>
        {advert.body && <p className="text-sm text-slate-300 mt-1 whitespace-pre-wrap" data-testid="advert-body">{advert.body}</p>}
        {ctaNote && <p className="text-xs text-teal-200 mt-2 font-semibold">{ctaNote}</p>}
        <Button onClick={onStart} className="mt-4 h-11 bg-teal-500 hover:bg-teal-400 text-slate-900 font-bold" data-testid="mw-start-btn">{advert.cta_label || 'Start my website order'} <ArrowRight className="w-4 h-4 ml-1" /></Button>
      </div>
    </div>
  );
}
